import { NotificationDTO, NotificationTypes } from '../types/notifications'
import { useMemo } from 'react'
import { SurfaceType } from 'containers/likes/types/likes'
import { useNotificationsLikeUserInfo } from './notifications-users'

export const useNotificationsLikeTexts = (
  notification: Extract<
    NotificationDTO,
    { notificationType: NotificationTypes.LIKE }
  >
) => {
  const { isUserOwner, profileOwner } =
    useNotificationsLikeUserInfo(notification)

  const texts = useMemo(() => {
    const isProject =
      notification.specificData.surfaceType === SurfaceType.PROJECT
    const ownerLikedText = !isUserOwner
      ? `${profileOwner?.firstName}${
          profileOwner?.lastName ? ` ${profileOwner?.lastName}'s` : `'s`
        }`
      : ''
    const likedText = `liked${isUserOwner ? ` your` : ''}`
    const likedItemText = isProject ? 'Project' : 'Highlight'

    return {
      ownerLikedText,
      likedText,
      likedItemText,
    }
  }, [
    notification.specificData.surfaceType,
    isUserOwner,
    profileOwner?.firstName,
    profileOwner?.lastName,
  ])

  return {
    ...texts,
  }
}
